import React from "react";
import User from "../../api/User";
import { ItemRight } from "./ItemRight";
import { observer } from "mobx-react-lite";
import Loader from "../Loader";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import ApiData from "../../api/ApiData";

export const ListRight = observer(
  ({
    actionRole,
    actionEmploees,
    actionAdminRole,
    // , setAdminClientIDFunc
  }) => {
    return User.flag_permission ? (
      <div className="admin_permission_select_container">
        {User.group_rights.map((group_category) => (
          <React.Fragment key={group_category}>
            <div className="group_category_role_block">
              <div className="group_category_role_title">{group_category}</div>
              <ul className="group_category_role_block_checkbox">
                {User.role_permission_data
                  .filter(
                    (right) =>
                      group_category === right.category &&
                      !User.admin_user.includes(right.name_rights) &&
                      !User.admin_role.includes(right.name_rights) &&
                      !User.admin_clientid.includes(right.name_rights) &&
                      !User.patch_subscription.includes(right.name_rights) &&
                      !User.company_partner_link_rights.includes(
                        right.name_rights,
                      ) &&
                      !User.company_partners_master_rights.includes(
                        right.name_rights,
                      ) &&
                      !User.hidden_rights_ui.includes(right.name_rights) &&
                      right.name_rights !== "patch_superuser_id" &&
                      right.name_rights !== "post_verification" &&
                      right.name_rights !== "get_all_production" &&
                      right.name_rights !== "get_soft_product_id" &&
                      right.name_rights !== "get_license_id" &&
                      right.name_rights !== "get_country" &&
                      right.name_rights !== "patch_attach_id" &&
                      right.name_rights !== "patch_licen_prol_id" &&
                      right.name_rights !== "get_filter_country" &&
                      right.name_rights !== "get_expiring_codes" &&
                      right.name_rights !== "patch_activity_license_id" &&
                      right.name_rights !== "delete_production" &&
                      right.name_rights !== "get_subscription" &&
                      right.name_rights !== "patch_company_assign_manager" &&
                      right.name_rights !== "patch_company_assign_support_manager"
                  )
                  .map((right) => (
                    <ItemRight
                      actionRole={actionRole}
                      right={right}
                      key={right.id}
                    />
                  ))}
              </ul>
            </div>
            {group_category === "Компании" ? (
              <>
              <div className="group_category_role_block">
                <div className="group_category_role_title">Партнёры</div>
                <ul className="group_category_role_block_checkbox">
                  {User.role_permission_data
                    .filter((right) =>
                      User.company_partners_master_rights.includes(
                        right.name_rights,
                      ),
                    )
                    .map((right) => (
                      <ItemRight
                        actionRole={actionRole}
                        right={right}
                        key={right.id}
                      />
                    ))}
                </ul>
              </div>
              <div className="group_category_role_block">
                <div className="group_category_role_title">
                  Назначение компаний партнёрам
                </div>
                <ul className="group_category_role_block_checkbox">
                  {User.role_permission_data
                    .filter((right) =>
                      User.company_partner_link_rights.includes(
                        right.name_rights,
                      ),
                    )
                    .map((right) => (
                      <ItemRight
                        actionRole={actionRole}
                        right={right}
                        key={right.id}
                      />
                    ))}
                </ul>
              </div>
              </>
            ) : null}
          </React.Fragment>
        ))}
        {User.user.is_superuser && User.role_permission_data.length !== 0 ? (
          <ul className="group_category_role_block ">
            <li className="group_category_role_title">
              Администрирование системы
            </li>
            <li className="group_category_role_block_checkbox">
              <label className="flx-sb mrg-btm-10 ">
                <span className="role_item_text">Управление сотрудниками</span>{" "}
                {User.role_permission_data
                  .filter((r) => r.name_rights === "post_user")
                  .map((r) => (
                    <div key={r.id}>
                      <CcV4Toggle
                        onClick={() => actionEmploees()}
                        active={r.activ}
                      />
                    </div>
                  ))}
              </label>
              <label className="flx-sb mrg-btm-10 ">
                <span className="role_item_text">Управление ролями</span>{" "}
                {User.role_permission_data
                  .filter((r) => r.name_rights === "get_roles_id")
                  .map((r) => (
                    <div key={r.id}>
                      <CcV4Toggle
                        onClick={() => actionRole(r)}
                        active={r.activ}
                      />
                    </div>
                  ))}
              </label>
              <label className="flx-sb mrg-btm-10 ">
                <span className="role_item_text">Управление клиентами ИД</span>{" "}
                {User.role_permission_data
                  .filter((r) => r.name_rights === "patch_client_id")
                  .map((r) => (
                    <div key={r.id}>
                      <CcV4Toggle
                        onClick={() => actionRole(r)}
                        active={r.activ}
                      />
                    </div>
                  ))}
              </label>
            </li>
          </ul>
        ) : (
          <ul className="group_category_role_block_checkbox">
            <li className="role_item_admin_superuser_title">
              Для настройки прав администратора, обратитесь к сотрудникам:
            </li>
            {ApiData.employees
              .filter((e) => e.is_superuser && e.is_active)
              .map((e) => (
                <li className="role_item_admin_superuser_title_user" key={e.id}>
                  {e.last_name} {e.first_name}
                </li>
              ))}
          </ul>
        )}
      </div>
    ) : (
      <Loader />
    );
  }
);
